
<el-select
  :value="vnodeId"
  class="pb-3"
  placeholder="choose a popup"
  @input="(value) => change(value)"
>
  <el-option
    v-for="(popup, idx) in popupListData"
    :key="idx"
    :label="fmtName(popup, idx + 1)"
    :value="popup"
  >
  </el-option>
</el-select>
